import {
	MSG_DISABLE_ACTION,
	MSG_ENABLE_ACTION,
	ROOM_ID_REMOVE_ACTION,
	ROOM_ID_SET_ACTION,
	SET_USER_ACTION,
} from "../reducers/MsgReducer";

export function msgAction(status) {
	if (status === true) {
		return {
			type: MSG_ENABLE_ACTION,
			payload: status,
		};
	}

	return {
		type: MSG_DISABLE_ACTION,
		payload: status,
	};
}
export function roomAction(roomId) {
	if (roomId) {
		return {
			type: ROOM_ID_SET_ACTION,
			payload: roomId,
		};
	}

	return {
		type: ROOM_ID_REMOVE_ACTION,
		payload: roomId,
	};
}
export function chatUserAction(user) {
	return {
		type: SET_USER_ACTION,
		payload: user,
	};
}
